<script>
  let selected = "";
  $: console.log(selected);
  import Customaddposition from "./Customaddposition.svelte";
</script>

<div class="col-12">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Positions</h3>
      <div class="ms-auto">
        <button
          class="btn btn-primary d-none d-sm-inline-block"
          data-bs-toggle="modal"
          data-bs-target="#modal-add"
        >
          <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
          Add
        </button>
        <button
          class="btn btn-primary d-sm-none btn-icon"
          data-bs-toggle="modal"
          data-bs-target="#modal-add"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table card-table table-vcenter text-nowrap datatable">
        <thead>
          <tr>
            <th class="w-1">b/s </th>
            <th>symbol</th>
            <th>type</th>
            <th>entry</th>
            <th>profit target</th>

            <th>stop loss</th>
            <th>expiry</th>
            <th>lots</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span class="bg-green-lt"> B </span>
            </td>
            <td><span>NIFTY</span> </td>
            <td>
              <span>Call</span>
            </td>
            <td>
              <span>ATM + 100</span>
            </td>
            <td> 10% </td>
            <td> 1000 </td>
            <td> Weekly + 1 </td>
            <td>3</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--Strategy Setting-->

<div class="col-12">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Strategy Settings</h3>
    </div>
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-3">
            <div class="mb-3">
              <span class="form-label mb-3">Square Off </span>
              <div>
                <label class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" checked />
                  <span class="form-check-label">One Leg</span>
                </label>
                <label class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" />
                  <span class="form-check-label">All Legs</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <span class="form-label">Holding Period </span>

            <div class="mb-3">
              <select class="form-select">
                <option>Intraday</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="mb-3">
              <div>
                <label class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" />
                  <span class="form-check-label">Set Profit Target</span>
                </label>
                <label class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" checked />
                  <span class="form-check-label">Set Stop Loss</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <span class="form-label">Entry By</span>
              <div class="form-selectgroup">
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    class="form-selectgroup-input"
                    value="Buy"
                  />
                  <span class="form-selectgroup-label">Strike</span>
                </label>
                <label class="form-selectgroup-item">
                  <input
                    type="radio"
                    class="form-selectgroup-input"
                    value="Sell"
                  />
                  <span class="form-selectgroup-label">Value</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <span class="form-label">Strike Price(ATM)</span>
              <select class="form-select" bind:value={selected}>
                <option>item</option>
              </select>
            </div>
          </div>
          <div class="mb-3">
            <div>
              <label class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" />
                <span class="form-check-label">Set Profit Target</span>
              </label>
              <label class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" checked />
                <span class="form-check-label">Set Stop Loss</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<Customaddposition />
